import { UnitsOfLength } from '@race-planner/aws-amplify/src/models';
import {
    convertKilometersToMeters,
    convertMilesToMeters,
    convertSecondsToMinutes
} from '@race-planner/unit-converters';

const distanceToMetersConverters = {
    [UnitsOfLength.METRIC]: value => convertKilometersToMeters(value),
    [UnitsOfLength.STATUTE]: value => convertMilesToMeters(value)
};

export const calculateRunDistanceForPace = ({
    timeInSeconds,
    paceInSeconds,
    unitsOfLength
}) => {
    if (paceInSeconds === 0) {
        return 0;
    }

    return distanceToMetersConverters[unitsOfLength](
        convertSecondsToMinutes(timeInSeconds) / convertSecondsToMinutes(paceInSeconds)
    );
};
